import { Action } from '@ngrx/store';
import { TransportationType } from '@signal/asp-data-commons';
import { ShopMaxPerDay, MasterSlot, ShopMaxPerTime, PerDaySlotsForCustomData, TeamMaxPerTime, TechnicianSlotsPerTeam, ActivateIndicator, TechnicianActivateIndicator, ShuttleActivateIndicator, RentalActivateIndicator, RemoteActivateIndicator } from '../../shared/models/slot-management.model';

export enum SlotActionTypes {
    LOAD_MASTER_SLOTS = '[Slot Management] Load master Slots details',
    LOAD_MASTER_SLOTS_SUCCESS = '[Slot Management] Load master slots details success',
    LOAD_MASTER_SLOTS_FAILURE = '[Slot Management] Load master slots details failure',
    /* shop capacity */
    LOAD_SHOP_MAX_SLOTS = '[Slot Management] Load shop max Slots details',
    LOAD_SHOP_MAX_SLOTS_SUCCESS = '[Slot Management] Load shop max slots details success',
    LOAD_SHOP_MAX_SLOTS_FAILURE = '[Slot Management] Load shop max slots details failure',
    LOAD_SHOP_MAX_TOTAL = '[Slot Management] Load shop max total details',
    LOAD_SHOP_MAX_TOTAL_SUCCESS = '[Slot Management] Load shop max total details success',
    LOAD_SHOP_MAX_TOTAL_FAILURE = '[Slot Management] Load shop max total details failure',
    UPDATE_SHOP_MAX_TOTAL = '[Slot Management] Update shop max total details',
    UPDATE_SHOP_MAX_TOTAL_SUCCESS = '[Slot Management] Update shop max total details success',
    UPDATE_SHOP_MAX_TOTAL_FAILURE = '[Slot Management] Update shop max total details failure',
    UPDATE_SHOP_MAX_SLOTS = '[Slot Management] Update shop max slots details',
    UPDATE_SHOP_MAX_SLOTS_SUCCESS = '[Slot Management] Update shop max slots details success',
    UPDATE_SHOP_MAX_SLOTS_FAILURE = '[Slot Management] Update shop max slots details failure',

    /* team capacity */
    LOAD_TEAM_MAX_SLOTS = '[Slot Management] Load team max Slots details',
    LOAD_TEAM_MAX_SLOTS_SUCCESS = '[Slot Management] Load team max slots details success',
    LOAD_TEAM_MAX_SLOTS_FAILURE = '[Slot Management] Load team max slots details failure',
    LOAD_TEAM_MAX_TOTAL = '[Slot Management] Load team max total details',
    LOAD_TEAM_MAX_TOTAL_SUCCESS = '[Slot Management] Load team max total details success',
    LOAD_TEAM_MAX_TOTAL_FAILURE = '[Slot Management] Load team max total details failure',
    UPDATE_TEAM_MAX_TOTAL = '[Slot Management] Update team max total details',
    UPDATE_TEAM_MAX_TOTAL_SUCCESS = '[Slot Management] Update team max total details success',
    UPDATE_TEAM_MAX_TOTAL_FAILURE = '[Slot Management] Update team max total details failure',
    UPDATE_TEAM_MAX_SLOTS = '[Slot Management] Update team max slots details',
    UPDATE_TEAM_MAX_SLOTS_SUCCESS = '[Slot Management] Update team max slots details success',
    UPDATE_TEAM_MAX_SLOTS_FAILURE = '[Slot Management] Update team max slots details failure',

    /* technician capacity*/
    LOAD_TECHNICIAN_MAX_SLOTS = '[Slot Management] Load technician max Slots details',
    LOAD_TECHNICIAN_MAX_SLOTS_SUCCESS = '[Slot Management] Load technician max slots details success',
    LOAD_TECHNICIAN_MAX_SLOTS_FAILURE = '[Slot Management] Load technician max slots details failure',
    LOAD_TECHNICIAN_MAX_TOTAL = '[Slot Management] Load technician max total details',
    LOAD_TECHNICIAN_MAX_TOTAL_SUCCESS = '[Slot Management] Load technician max total details success',
    LOAD_TECHNICIAN_MAX_TOTAL_FAILURE = '[Slot Management] Load technician max total details failure',
    UPDATE_TECHNICIAN_MAX_TOTAL = '[Slot Management] Update technician max total details',
    UPDATE_TECHNICIAN_MAX_TOTAL_SUCCESS = '[Slot Management] Update technician max total details success',
    UPDATE_TECHNICIAN_MAX_TOTAL_FAILURE = '[Slot Management] Update technician max total details failure',
    UPDATE_TECHNICIAN_MAX_SLOTS = '[Slot Management] Update technician max slots details',
    UPDATE_TECHNICIAN_MAX_SLOTS_SUCCESS = '[Slot Management] Update technician max slots details success',
    UPDATE_TECHNICIAN_MAX_SLOTS_FAILURE = '[Slot Management] Update technician max slots details failure',

    /*Transport Capacity*/
    LOAD_TRANSPORT_MAX_TOTAL = '[Slot Management] Load transport max total details',
    LOAD_TRANSPORT_MAX_TOTAL_SUCCESS = '[Slot Management] Load transport max total details success',
    LOAD_TRANSPORT_MAX_TOTAL_FAILURE = '[Slot Management] Load transport max total details failure',
    LOAD_TRANSPORT_MAX_SLOTS = '[Slot Management] Load transport max Slots details',
    LOAD_TRANSPORT_MAX_SLOTS_SUCCESS = '[Slot Management] Load transport max slots details success',
    LOAD_TRANSPORT_MAX_SLOTS_FAILURE = '[Slot Management] Load transport max slots details failure',
    UPDATE_TRANSPORT_MAX_TOTAL = '[Slot Management] Update transport max total details',
    UPDATE_TRANSPORT_MAX_TOTAL_SUCCESS = '[Slot Management] Update transport max total details success',
    UPDATE_TRANSPORT_MAX_TOTAL_FAILURE = '[Slot Management] Update transport max total details failure',
    UPDATE_TRANSPORT_MAX_SLOTS = '[Slot Management] Update transport max slots details',
    UPDATE_TRANSPORT_MAX_SLOTS_SUCCESS = '[Slot Management] Update transport max slots details success',
    UPDATE_TRANSPORT_MAX_SLOTS_FAILURE = '[Slot Management] Update transport max slots details failure',

    //Indicators
    LOAD_ACTIVATE_INDICATOR = '[Slot Management] Load activate indicator',
    LOAD_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Load activate indicator success',
    LOAD_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Load activate indicator failure',
    UPDATE_ACTIVATE_INDICATOR = '[Slot Management] Update activate indicator',
    UPDATE_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Update activate indicator success',
    UPDATE_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Update activate indicator failure',
    LOAD_TECHNICIAN_ACTIVATE_INDICATOR = '[Slot Management] Load technician activate indicator',
    LOAD_TECHNICIAN_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Load technician activate indicator success',
    LOAD_TECHNICIAN_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Load technician activate indicator failure',
    UPDATE_TECHNICIAN_ACTIVATE_INDICATOR = '[Slot Management] Update technician activate indicator',
    UPDATE_TECHNICIAN_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Update technician activate indicator success',
    UPDATE_TECHNICIAN_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Update technician activate indicator failure',
    LOAD_SHUTTLE_ACTIVATE_INDICATOR = '[Slot Management] Load shuttle activate indicator',
    LOAD_SHUTTLE_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Load shuttle activate indicator success',
    LOAD_SHUTTLE_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Load shuttle activate indicator failure',
    UPDATE_SHUTTLE_ACTIVATE_INDICATOR = '[Slot Management] Update shuttle activate indicator',
    UPDATE_SHUTTLE_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Update shuttle activate indicator success',
    UPDATE_SHUTTLE_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Update shuttle activate indicator failure',
    LOAD_RENTAL_ACTIVATE_INDICATOR = '[Slot Management] Load rental activate indicator',
    LOAD_RENTAL_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Load rental activate indicator success',
    LOAD_RENTAL_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Load rental activate indicator failure',
    UPDATE_RENTAL_ACTIVATE_INDICATOR = '[Slot Management] Update rental activate indicator',
    UPDATE_RENTAL_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Update rental activate indicator success',
    UPDATE_RENTAL_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Update rental activate indicator failure',

    LOAD_REMOTE_ACTIVATE_INDICATOR = '[Slot Management] Load remote activate indicator',
    LOAD_REMOTE_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Load remote activate indicator success',
    LOAD_REMOTE_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Load remote activate indicator failure',
    UPDATE_REMOTE_ACTIVATE_INDICATOR = '[Slot Management] Update remote activate indicator',
    UPDATE_REMOTE_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Update remote activate indicator success',
    UPDATE_REMOTE_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Update remote activate indicator failure',

    LOAD_TXM_TEAM_ACTIVATE_INDICATOR = '[Slot Management] Load TXM team activate indicator',
    LOAD_TXM_TEAM_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Load TXM team activate indicator success',
    LOAD_TXM_TEAM_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Load TXM team activate indicator failure',
    UPDATE_TXM_TEAM_ACTIVATE_INDICATOR = '[Slot Management] Update TXM team activate indicator',
    UPDATE_TXM_TEAM_ACTIVATE_INDICATOR_SUCCESS = '[Slot Management] Update TXM team activate indicator success',
    UPDATE_TXM_TEAM_ACTIVATE_INDICATOR_FAILURE = '[Slot Management] Update TXM team activate indicator failure',
    /*TXM team capacity */
    LOAD_TXM_TEAM_MAX_SLOTS = '[Slot Management] Load TXM team max Slots details',
    LOAD_TXM_TEAM_MAX_SLOTS_SUCCESS = '[Slot Management] Load TXM team max slots details success',
    LOAD_TXM_TEAM_MAX_SLOTS_FAILURE = '[Slot Management] Load TXM team max slots details failure',
    LOAD_TXM_TEAM_MAX_TOTAL = '[Slot Management] Load TXM team max total details',
    LOAD_TXM_TEAM_MAX_TOTAL_SUCCESS = '[Slot Management] Load TXM team max total details success',
    LOAD_TXM_TEAM_MAX_TOTAL_FAILURE = '[Slot Management] Load TXM team max total details failure',
    UPDATE_TXM_TEAM_MAX_TOTAL = '[Slot Management] Update TXM team max total details',
    UPDATE_TXM_TEAM_MAX_TOTAL_SUCCESS = '[Slot Management] Update TXM team max total details success',
    UPDATE_TXM_TEAM_MAX_TOTAL_FAILURE = '[Slot Management] Update TXM team max total details failure',
    UPDATE_TXM_TEAM_MAX_SLOTS = '[Slot Management] Update TXM team max slots details',
    UPDATE_TXM_TEAM_MAX_SLOTS_SUCCESS = '[Slot Management] Update TXM team max slots details success',
    UPDATE_TXM_TEAM_MAX_SLOTS_FAILURE = '[Slot Management] Update TXM team max slots details failure',

}

export class LoadMasterSlots implements Action {
    readonly type: string = SlotActionTypes.LOAD_MASTER_SLOTS;

    constructor() {
    }
}

export class LoadMasterSlotsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_MASTER_SLOTS_SUCCESS;

    constructor(public payload: { masterSlots: MasterSlot[] }) {
    }
}

export class LoadMasterSlotsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_MASTER_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadShopMaxSlots implements Action {
    readonly type: string = SlotActionTypes.LOAD_SHOP_MAX_SLOTS;

    constructor() {
    }
}

export class LoadShopMaxSlotsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_SHOP_MAX_SLOTS_SUCCESS;

    constructor(public payload: { shopMaxSlots: ShopMaxPerTime }) {
    }
}

export class LoadShopMaxSlotsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_SHOP_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadShopMaxTotal implements Action {
    readonly type: string = SlotActionTypes.LOAD_SHOP_MAX_TOTAL;

    constructor() {
    }
}

export class LoadShopMaxTotalSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_SHOP_MAX_TOTAL_SUCCESS;

    constructor(public payload: { shopMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class LoadShopMaxTotalFailure implements Action {
    readonly type = SlotActionTypes.LOAD_SHOP_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateShopMaxTotal implements Action {
    readonly type: string = SlotActionTypes.UPDATE_SHOP_MAX_TOTAL;

    constructor(public payload: {shopMaxTotal : ShopMaxPerDay[]}) {
    }
}

export class UpdateShopMaxTotalSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_SHOP_MAX_TOTAL_SUCCESS;

    constructor(public payload: { shopMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class UpdateShopMaxTotalFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_SHOP_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateShopMaxSlots implements Action {
    readonly type: string = SlotActionTypes.UPDATE_SHOP_MAX_SLOTS

    constructor(public payload: {shopMaxSlots : ShopMaxPerTime,bothFormsEdited:boolean}) {
    }
}

export class UpdateShopMaxSlotsSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_SHOP_MAX_SLOTS_SUCCESS;

    constructor(public payload: { shopMaxSlots: ShopMaxPerTime }) {
    }
}

export class UpdateShopMaxSlotsFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_SHOP_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

/*team capacity */

export class LoadTeamMaxSlots implements Action {
    readonly type: string = SlotActionTypes.LOAD_TEAM_MAX_SLOTS;

    constructor() {
    }
}

export class LoadTeamMaxSlotsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_TEAM_MAX_SLOTS_SUCCESS;

    constructor(public payload: { teamMaxSlots: TeamMaxPerTime[] }) {
    }
}

export class LoadTeamMaxSlotsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_TEAM_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadTeamMaxTotal implements Action {
    readonly type: string = SlotActionTypes.LOAD_TEAM_MAX_TOTAL;

    constructor() {
    }
}

export class LoadTeamMaxTotalSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_TEAM_MAX_TOTAL_SUCCESS;

    constructor(public payload: { teamMaxTotal: PerDaySlotsForCustomData[] }) {
    }
}

export class LoadTeamMaxTotalFailure implements Action {
    readonly type = SlotActionTypes.LOAD_TEAM_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTeamMaxTotal implements Action {
    readonly type: string = SlotActionTypes.UPDATE_TEAM_MAX_TOTAL;

    constructor(public payload: {teamMaxTotal : PerDaySlotsForCustomData[],
    allFormsEdited:boolean}) {
    }
}

export class UpdateTeamMaxTotalSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_TEAM_MAX_TOTAL_SUCCESS;

    constructor(public payload: { teamMaxTotal: PerDaySlotsForCustomData[] }) {
    }
}

export class UpdateTeamMaxTotalFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_TEAM_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTeamMaxSlots implements Action {
    readonly type: string = SlotActionTypes.UPDATE_TEAM_MAX_SLOTS

    constructor(public payload: {teamMaxSlots : TeamMaxPerTime,allFormsEdited:boolean}) {
    }
}

export class UpdateTeamMaxSlotsSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_TEAM_MAX_SLOTS_SUCCESS;

    constructor(public payload: { teamMaxSlots: TeamMaxPerTime }) {
    }
}

export class UpdateTeamMaxSlotsFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_TEAM_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

/*technician capacity */

export class LoadTechnicianMaxSlots implements Action {
    readonly type: string = SlotActionTypes.LOAD_TECHNICIAN_MAX_SLOTS;

    constructor() {
    }
}

export class LoadTechnicianMaxSlotsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_TECHNICIAN_MAX_SLOTS_SUCCESS;

    constructor(public payload: { technicianMaxSlots: TechnicianSlotsPerTeam[] }) {
    }
}

export class LoadTechnicianMaxSlotsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_TECHNICIAN_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadTechnicianMaxTotal implements Action {
    readonly type: string = SlotActionTypes.LOAD_TECHNICIAN_MAX_TOTAL;

    constructor() {
    }
}

export class LoadTechnicianMaxTotalSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_TECHNICIAN_MAX_TOTAL_SUCCESS;

    constructor(public payload: { technicianMaxTotal: PerDaySlotsForCustomData[] }) {
    }
}

export class LoadTechnicianMaxTotalFailure implements Action {
    readonly type = SlotActionTypes.LOAD_TECHNICIAN_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTechnicianMaxTotal implements Action {
    readonly type: string = SlotActionTypes.UPDATE_TECHNICIAN_MAX_TOTAL;

    constructor(public payload: {technicianMaxTotal : PerDaySlotsForCustomData[]}) {
    }
}

export class UpdateTechnicianMaxTotalSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_TECHNICIAN_MAX_TOTAL_SUCCESS;

    constructor(public payload: { technicianMaxTotal: PerDaySlotsForCustomData[] }) {
    }
}

export class UpdateTechnicianMaxTotalFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_TECHNICIAN_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTechnicianMaxSlots implements Action {
    readonly type: string = SlotActionTypes.UPDATE_TECHNICIAN_MAX_SLOTS

    constructor(public payload: {technicianMaxSlots : TechnicianSlotsPerTeam}) {
    }
}

export class UpdateTechnicianMaxSlotsSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_TECHNICIAN_MAX_SLOTS_SUCCESS;

    constructor(public payload: { technicianMaxSlots: TechnicianSlotsPerTeam }) {
    }
}

export class UpdateTechnicianMaxSlotsFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_TECHNICIAN_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

/* Transport Capacity */
export class LoadTransportMaxSlots implements Action {
    readonly type: string = SlotActionTypes.LOAD_TRANSPORT_MAX_SLOTS;

    constructor(public payload: { transport: TransportationType }) {
    }
}

export class LoadTransportMaxSlotsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_TRANSPORT_MAX_SLOTS_SUCCESS;

    constructor(public payload: { transport: TransportationType, transportMaxSlots: ShopMaxPerTime }) {
    }
}

export class LoadTransportMaxSlotsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_TRANSPORT_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadTransportMaxTotal implements Action {
    readonly type: string = SlotActionTypes.LOAD_TRANSPORT_MAX_TOTAL;

    constructor(public payload: { transport: TransportationType }) {
    }
}

export class LoadTransportMaxTotalSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_TRANSPORT_MAX_TOTAL_SUCCESS;

    constructor(public payload: { transport: TransportationType, transportMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class LoadTransportMaxTotalFailure implements Action {
    readonly type = SlotActionTypes.LOAD_TRANSPORT_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTransportMaxTotal implements Action {
    readonly type: string = SlotActionTypes.UPDATE_TRANSPORT_MAX_TOTAL;

    constructor(public payload: { transport: TransportationType, transportMaxTotal: ShopMaxPerDay[],
     }) {
    }
}

export class UpdateTransportMaxTotalSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_TRANSPORT_MAX_TOTAL_SUCCESS;

    constructor(public payload: { transport: TransportationType, transportMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class UpdateTransportMaxTotalFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_TRANSPORT_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTransportMaxSlots implements Action {
    readonly type: string = SlotActionTypes.UPDATE_TRANSPORT_MAX_SLOTS

    constructor(public payload: { transport: TransportationType, transportMaxSlots: ShopMaxPerTime,
    bothFormsEdited:boolean }) {
    }
}

export class UpdateTransportMaxSlotsSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_TRANSPORT_MAX_SLOTS_SUCCESS;

    constructor(public payload: { transport: TransportationType, transportMaxSlots: ShopMaxPerTime }) {
    }
}

export class UpdateTransportMaxSlotsFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_TRANSPORT_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

//Indicators
export class LoadActivateIndicators implements Action {
    readonly type: string = SlotActionTypes.LOAD_ACTIVATE_INDICATOR;

    constructor() {
    }
}

export class LoadActivateIndicatorsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { activateIndicators: ActivateIndicator[] }) {
    }
}

export class LoadActivateIndicatorsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateActivateIndicators implements Action {
    readonly type: string = SlotActionTypes.UPDATE_ACTIVATE_INDICATOR;

    constructor(public payload: {indicator : boolean}) {
    }
}

export class UpdateActivateIndicatorsSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { activateIndicators: ActivateIndicator[] }) {
    }
}

export class UpdateActivateIndicatorsFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadTechnicianActivateIndicators implements Action {
    readonly type: string = SlotActionTypes.LOAD_TECHNICIAN_ACTIVATE_INDICATOR;

    constructor() {
    }
}

export class LoadTechnicianActivateIndicatorsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_TECHNICIAN_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { technicianactivateIndicators: TechnicianActivateIndicator[] }) {
    }
}

export class LoadTechnicianActivateIndicatorsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_TECHNICIAN_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTechnicianActivateIndicators implements Action {
    readonly type: string = SlotActionTypes.UPDATE_TECHNICIAN_ACTIVATE_INDICATOR;

    constructor(public payload: {indicator : boolean}) {
    }
}

export class UpdateTechnicianActivateIndicatorsSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_TECHNICIAN_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { technicianactivateIndicators: TechnicianActivateIndicator[] }) {
    }
}

export class UpdateTechnicianActivateIndicatorsFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_TECHNICIAN_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadShuttleActivateIndicators implements Action {
    readonly type: string = SlotActionTypes.LOAD_SHUTTLE_ACTIVATE_INDICATOR;

    constructor() {
    }
}

export class LoadShuttleActivateIndicatorsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_SHUTTLE_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { shuttleactivateIndicators: ShuttleActivateIndicator[] }) {
    }
}

export class LoadShuttleActivateIndicatorsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_SHUTTLE_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateShuttleActivateIndicators implements Action {
    readonly type: string = SlotActionTypes.UPDATE_SHUTTLE_ACTIVATE_INDICATOR;

    constructor(public payload: {indicator : boolean}) {
    }
}

export class UpdateShuttleActivateIndicatorsSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_SHUTTLE_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { shuttleactivateIndicators: ShuttleActivateIndicator[] }) {
    }
}

export class UpdateShuttleActivateIndicatorsFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_SHUTTLE_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadRentalActivateIndicators implements Action {
    readonly type: string = SlotActionTypes.LOAD_RENTAL_ACTIVATE_INDICATOR;

    constructor() {
    }
}

export class LoadRentalActivateIndicatorsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_RENTAL_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { rentalactivateIndicators: RentalActivateIndicator[] }) {
    }
}

export class LoadRentalActivateIndicatorsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_RENTAL_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateRentalActivateIndicators implements Action {
    readonly type: string = SlotActionTypes.UPDATE_RENTAL_ACTIVATE_INDICATOR;

    constructor(public payload: {indicator : boolean}) {
    }
}

export class UpdateRentalActivateIndicatorsSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_RENTAL_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { rentalactivateIndicators: RentalActivateIndicator[] }) {
    }
}

export class UpdateRentalActivateIndicatorsFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_RENTAL_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadRemoteActivateIndicators implements Action {
    readonly type: string = SlotActionTypes.LOAD_REMOTE_ACTIVATE_INDICATOR;

    constructor() {
    }
}

export class LoadRemoteActivateIndicatorsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_REMOTE_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { remoteactivateIndicators: RemoteActivateIndicator[] }) {
    }
}

export class LoadRemoteActivateIndicatorsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_REMOTE_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateRemoteActivateIndicators implements Action {
    readonly type: string = SlotActionTypes.UPDATE_REMOTE_ACTIVATE_INDICATOR;

    constructor(public payload: {indicator : boolean}) {
    }
}

export class UpdateRemoteActivateIndicatorsSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_REMOTE_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { remoteactivateIndicators: RemoteActivateIndicator[] }) {
    }
}

export class UpdateRemoteActivateIndicatorsFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_REMOTE_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

/*TXM team capacity */

export class LoadTxmTeamMaxSlots implements Action {
    readonly type: string = SlotActionTypes.LOAD_TXM_TEAM_MAX_SLOTS;

    constructor() {
    }
}

export class LoadTxmTeamMaxSlotsSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_TXM_TEAM_MAX_SLOTS_SUCCESS;

    constructor(public payload: { txmTeamMaxSlots: ShopMaxPerTime }) {
    }
}

export class LoadTxmTeamMaxSlotsFailure implements Action {
    readonly type = SlotActionTypes.LOAD_TXM_TEAM_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadTxmTeamMaxTotal implements Action {
    readonly type: string = SlotActionTypes.LOAD_TXM_TEAM_MAX_TOTAL;

    constructor() {
    }
}

export class LoadTxmTeamMaxTotalSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_TXM_TEAM_MAX_TOTAL_SUCCESS;

    constructor(public payload: { txmTeamMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class LoadTxmTeamMaxTotalFailure implements Action {
    readonly type = SlotActionTypes.LOAD_TXM_TEAM_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTxmTeamMaxTotal implements Action {
    readonly type: string = SlotActionTypes.UPDATE_TXM_TEAM_MAX_TOTAL;

    constructor(public payload: {txmTeamMaxTotal : ShopMaxPerDay[]}) {
    }
}

export class UpdateTxmTeamMaxTotalSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_TXM_TEAM_MAX_TOTAL_SUCCESS;

    constructor(public payload: { txmTeamMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class UpdateTxmTeamMaxTotalFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_TXM_TEAM_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTxmTeamMaxSlots implements Action {
    readonly type: string = SlotActionTypes.UPDATE_TXM_TEAM_MAX_SLOTS

    constructor(public payload: {txmTeamMaxSlots : ShopMaxPerTime,bothFormsEdited:boolean}) {
    }
}

export class UpdateTxmTeamMaxSlotsSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_TXM_TEAM_MAX_SLOTS_SUCCESS;

    constructor(public payload: { txmTeamMaxSlots: ShopMaxPerTime }) {
    }
}

export class UpdateTxmTeamMaxSlotsFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_TXM_TEAM_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadTxmTeamActivateIndicator implements Action {
    readonly type: string = SlotActionTypes.LOAD_TXM_TEAM_ACTIVATE_INDICATOR;

    constructor() {
    }
}

export class LoadTxmTeamActivateIndicatorSuccess implements Action {
    readonly type = SlotActionTypes.LOAD_TXM_TEAM_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { txmActivateIndicators: ActivateIndicator[] }) {
    }
}

export class LoadTxmTeamActivateIndicatorFailure implements Action {
    readonly type = SlotActionTypes.LOAD_TXM_TEAM_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTxmTeamActivateIndicator implements Action {
    readonly type: string = SlotActionTypes.UPDATE_TXM_TEAM_ACTIVATE_INDICATOR;

    constructor(public payload: {indicator : boolean}) {
    }
}

export class UpdateTxmTeamActivateIndicatorSuccess implements Action {
    readonly type = SlotActionTypes.UPDATE_TXM_TEAM_ACTIVATE_INDICATOR_SUCCESS;

    constructor(public payload: { txmActivateIndicators: ActivateIndicator[] }) {
    }
}

export class UpdateTxmTeamActivateIndicatorFailure implements Action {
    readonly type = SlotActionTypes.UPDATE_TXM_TEAM_ACTIVATE_INDICATOR_FAILURE;

    constructor(public payload: { error: string }) {
    }
}


export type SlotActions =
    LoadMasterSlots
    | LoadMasterSlotsSuccess
    | LoadMasterSlotsFailure
    | LoadShopMaxSlots
    | LoadShopMaxSlotsSuccess
    | LoadShopMaxSlotsFailure
    | LoadShopMaxTotal
    | LoadShopMaxTotalSuccess
    | LoadShopMaxTotalFailure
    | UpdateShopMaxTotal
    | UpdateShopMaxTotalSuccess
    | UpdateShopMaxTotalFailure
    | UpdateShopMaxSlots
    | UpdateShopMaxSlotsSuccess
    | UpdateShopMaxSlotsFailure
    | LoadTeamMaxSlots
    | LoadTeamMaxSlotsSuccess
    | LoadTeamMaxSlotsFailure
    | LoadTeamMaxTotal
    | LoadTeamMaxTotalSuccess
    | LoadTeamMaxTotalFailure
    | UpdateTeamMaxTotal
    | UpdateTeamMaxTotalSuccess
    | UpdateTeamMaxTotalFailure
    | UpdateTeamMaxSlots
    | UpdateTeamMaxSlotsSuccess
    | UpdateTeamMaxSlotsFailure
    | LoadTechnicianMaxSlots
    | LoadTechnicianMaxSlotsSuccess
    | LoadTechnicianMaxSlotsFailure
    | LoadTechnicianMaxTotal
    | LoadTechnicianMaxTotalSuccess
    | LoadTechnicianMaxTotalFailure
    | UpdateTechnicianMaxTotal
    | UpdateTechnicianMaxTotalSuccess
    | UpdateTechnicianMaxTotalFailure
    | UpdateTechnicianMaxSlots
    | UpdateTechnicianMaxSlotsSuccess
    | UpdateTechnicianMaxSlotsFailure
    | LoadTransportMaxSlots
    | LoadTransportMaxSlotsSuccess
    | LoadTransportMaxSlotsFailure
    | LoadTransportMaxTotal
    | LoadTransportMaxTotalSuccess
    | LoadTransportMaxTotalFailure
    | UpdateTransportMaxTotal
    | UpdateTransportMaxTotalSuccess
    | UpdateTransportMaxTotalFailure
    | UpdateTransportMaxSlots
    | UpdateTransportMaxSlotsSuccess
    | UpdateTransportMaxSlotsFailure
    | LoadActivateIndicators
    | LoadActivateIndicatorsSuccess
    | LoadActivateIndicatorsFailure
    | UpdateActivateIndicators
    | UpdateActivateIndicatorsSuccess
    | UpdateActivateIndicatorsFailure
    | LoadTechnicianActivateIndicators
    | LoadTechnicianActivateIndicatorsSuccess
    | LoadTechnicianActivateIndicatorsFailure
    | UpdateTechnicianActivateIndicators
    | UpdateTechnicianActivateIndicatorsSuccess
    | UpdateTechnicianActivateIndicatorsFailure
    | LoadShuttleActivateIndicators
    | LoadShuttleActivateIndicatorsSuccess
    | LoadShuttleActivateIndicatorsFailure
    | UpdateShuttleActivateIndicators
    | UpdateShuttleActivateIndicatorsSuccess
    | UpdateShuttleActivateIndicatorsFailure
    | LoadRentalActivateIndicators
    | LoadRentalActivateIndicatorsSuccess
    | LoadRentalActivateIndicatorsFailure
    | UpdateRentalActivateIndicators
    | UpdateRentalActivateIndicatorsSuccess
    | UpdateRentalActivateIndicatorsFailure
    | LoadRemoteActivateIndicatorsFailure
    | UpdateRemoteActivateIndicators
    | UpdateRemoteActivateIndicatorsSuccess
    | UpdateRemoteActivateIndicatorsFailure
    ;
